// extracted by mini-css-extract-plugin
export default {"lazy":"_61c0e446","lazyWithLineBreak":"_1f5b2bd5"};